import { create } from "zustand";

interface AnimationData {
  [key: string]: any; // Consider specifying a more accurate type for the animation data
}

interface AnimationState {
  animations: AnimationData;
  loading: boolean;
  loadAnimations: () => Promise<void>;
}

const LottieFiles = {
  chartAnimation: "1_Charts.json",
  brainAnimation: "2_Brain.json",
  armAnimation: "7_Arm.json",
  botBuiltAnimation: "bot_built.json",
  botCongratsAnimation: "bot_congrats.json",
  botSadAnimation: "bot_sad.json",
  cyborgBrainAnimation: "Cyborg Brain.json",
  targetAnimation: "Target.json",
  trophyAnimation: "Trophy.json",
  botAnimation: "10_Bot.json",
  blueprintAnimation: "11_Blueprint.json",
  traderAnimation: "1_Trader.json",
  virtualAnimation: "1_Virtual.json",
  notificationAnimation: "2_Notification.json",
  congratsAnimation: "Congrats.json",
  heartAnimation: "Heart.json",
  softwareAnimation: "2_Software.json",
  safeAnimation: "3_Safe.json",
  smartControlAnimation: "3_Smart Control.json",
  thinkingAnimation: "4_Thinking.json",
  learningAnimation: "5_Learning.json",
  assistantAnimation: "6_Assistant.json",
  motionAnimation: "8_Motion.json",
  integrationAnimation: "9_Integration.json",
  badgeAnimation: "Badge.json",
  connectingAnimation: "Connecting.json",
  bouncingBotAnimation: "Bouncing Bot.json",
  bouncingBot2Animation: "Bouncing Bot2.json",
  bouncingBot3Animation: "Bouncing Bot3.json",
  bouncingBot4Animation: "Bouncing Bot4.json"
};
const URL = "https://storage.googleapis.com/qp-bot-logos/";

export const useAnimationStore = create<AnimationState>(set => ({
  animations: {},
  loading: false,
  loadAnimations: async () => {
    set({ loading: true });

    const entries = Object.entries(LottieFiles);
    const promises = entries.map(async ([key, filename]) => {
      try {
        const url = `${URL}${encodeURIComponent(filename)}`;
        const response = await fetch(url, {
          headers: { "Content-Type": "application/json" }
        });
        const animationData = await response.json();

        // Update the state with the loaded animation data, using the key
        set(state => ({
          animations: {
            ...state.animations,
            [key]: animationData // Use the key for mapping
          }
        }));
      } catch (error) {
        console.error("Failed to load animation:", key, error);
        // Optionally handle error state here, could set failed loads to null or a specific error state
      }
    });

    await Promise.all(promises);
    set({ loading: false });
  }
}));

// Usage example
// In a React component:
// const loadAnimations = useAnimationStore(state => state.loadAnimations);
// useEffect(() => {
//   loadAnimations();
// }, [loadAnimations]);
